<!-- eslint-disable vue/html-self-closing -->
<template>
  <div
    v-if="mergeRequest"
    class="col-12"
  >
    <div
      class="d-flex flex-column"
      :class="{ 'mb-3': $route.name !== 'merge-request-pipeline' }"
    >
      <div class="d-flex flex-sm-row flex-column align-items-start justify-content-sm-between">
        <div class="d-flex mb-2">
          <div
            v-if="cicdEnabled"
            class="d-flex align-items-start merge-request-icon"
          >
            <merge-request-ci-pipeline-status />
          </div>
          <div
            v-if="mergeRequest.workInProgress"
            class="d-flex align-items-start merge-request-icon"
          >
            <span>
              <i
                class="gf-icon gf-icon-lock"
                :style="'font-size: 30px'"
              />
            </span>
          </div>
          <h4 class="d-flex align-items-start text-muted text-nowrap mb-0 mt-1 mx-2">
            <span>#{{ mergeRequest.localId }}</span>
          </h4>
          <h4 class="d-flex align-items-start text-break d-flex mr-3 mb-0 mt-1">
            <span>
              {{ mergeRequest.title || $t('message.title_empty') }}
            </span>
          </h4>
        </div>
        <!-- кнопка редактирования отображается в зависимости от доступов -->
        <div
          v-if="hasEditAccess"
          class="d-flex flex-shrink-1 mt-2 mt-md-0 mb-3"
        >
          <div class="col px-0">
            <a
              :href="
                '/project/' +
                $route.params.alias +
                '/' +
                $route.params.projectAlias +
                '/merge-request/' +
                $route.params.id +
                '/edit'
              "
              class="btn btn-block btn-dark btn-sm"
            >
              {{ $t('message.edit') }}
            </a>
          </div>
        </div>
      </div>

      <div class="d-flex flex-column">
        <div
          v-if="mergeRequest.createdBy"
          class="text-muted d-flex align-items-center flex-wrap text-break"
        >
          <a :href="'/user/' + mergeRequest.createdBy.username">
            <img
              :src="mergeRequest.createdBy.avatar"
              class="rounded-circle mr-1"
              height="20px"
              width="20px"
            />
          </a>

          <a
            class="font-weight-bolder text-muted mr-1"
            :href="'/user/' + mergeRequest.createdBy.username"
          >
            {{ mergeRequest.createdBy.fullName }}
          </a>
          <span class="mr-1">{{ $t('wants_to_merge_branch') }}</span>
          <span
            v-if="mergeRequest.sourceBranch.isDeleted"
            class="font-weight-bold mr-1"
          >
            {{ mergeRequest.sourceBranch.title }}
          </span>
          <span
            v-else
            class="mr-1 text-break"
          >
            <a
              :href="
                '/project/' +
                mergeRequest.sourceProject.ownerAlias +
                '/' +
                mergeRequest.sourceProject.alias +
                '?branch=' +
                mergeRequest.sourceBranch.id
              "
            >
              {{ mergeRequest.sourceProject.ownerAlias }}/{{ mergeRequest.sourceProject.alias }}
              -
              {{ mergeRequest.sourceBranch.title }}
            </a>
          </span>

          <span class="mr-1 text-break">{{ $tc('message.branch', 2) }}</span>

          <span
            v-if="mergeRequest.targetBranch.isDeleted"
            class="font-weight-bold mr-1"
          >
            {{ mergeRequest.targetBranch.title }} &nbsp;
          </span>
          <span
            v-else
            class="mr-1 text-break"
          >
            <a
              :href="
                '/project/' +
                $route.params.alias +
                '/' +
                $route.params.projectAlias +
                '?branch=' +
                mergeRequest.targetBranch.id
              "
            >
              {{ mergeRequest.targetBranch.title }}
            </a>
          </span>
        </div>

        <div
          v-if="mergeRequest.sourceBeforeTargetCommitCount > 0"
          class="text-muted mt-2"
        >
          {{ $t('branch_source') }}
          <span class="text-primary">
            {{ $t('lags_behind') }}
            <template v-if="mergeRequest.sourceBeforeTargetCommitCount > 20">20+</template>
            <template v-else>{{ mergeRequest.sourceBeforeTargetCommitCount }}</template>
            {{ $tc('commit', 3) }}
          </span>
        </div>

        <div class="d-flex align-items-center mt-2">
          <status-label :status="mergeRequest.status" />
          <!-- каунтер дискуссий отображается только если просмотр дискуссий доступен пользователю -->
          <div
            v-if="getActionAvailabilityFlag(ACTION_ENUM.READ_DISCUSSION)"
            class="d-flex flex-row text-muted align-items-center ml-1"
          >
            <i class="gf-icon gf-icon-comment mr-1" />
            <span>{{ mergeRequest.discussionCount }}</span>
          </div>
        </div>
      </div>

      <!-- вкладка с конвейерами отображается только если просмотр ci/cd доступен пользователю -->
      <merge-request-item-tabs
        :show-ci="cicdEnabled"
        :show-security="getActionAvailabilityFlag(ACTION_ENUM.READ_VULNERABILITY)"
      />
    </div>

    <router-view />
  </div>

  <pacman-loader v-else />
</template>

<script>
import MergeRequestService from '@shared/services/merge-request.service';
import mergeRequestMessages from '@shared/modules/merge-request/mergeRequestMessages';
import StatusLabel from '@shared/shared-components/status-label';
import PacmanLoader from '@shared/shared-components/shared/packman-loader';
import Vue from 'vue';
import referenceService from '@shared/services/reference.service';
// eslint-disable-next-line import/no-unresolved
import MergeRequestItemTabs from '../components/merge-request-item-tabs';
import ACTION_ENUM from '@shared/modules/custom-roles/custom-roles.constants';

export default {
  // eslint-disable-next-line vue/match-component-file-name
  name: 'PageMergeRequestList',
  components: { PacmanLoader, StatusLabel, MergeRequestItemTabs },
  data() {
    return {
      hasAccess: false,
      hasEditAccess: false
    };
  },
  methods: {
    getActionAvailabilityFlag(action) {
      return this.$store.getters.getActionAvailabilityFlag(action);
    }
  },
  computed: {
    ACTION_ENUM() {
      return ACTION_ENUM;
    },
    mergeRequest() {
      return this.$store.getters.getSelectedMergeRequest || {};
    },
    cicdEnabled() {
      return (
        this.$store.getters.getCicdStatus && this.getActionAvailabilityFlag(ACTION_ENUM.READ_CI_CD)
      );
    },
    applicationVersion() {
      return this.$store.getters.getApplicationVersion;
    }
  },
  mounted() {
    // тут отдельный инпут, потому что проверка идет не над проектом (как для остальных действий)
    // а над самим реквестом, тк есть доп условия (статус реквеста и автор ли юзер)
    this.hasEditAccess = document.getElementById('hasEditAccess')?.getAttribute('value') === 'true';

    referenceService.getCicdStatus();

    MergeRequestService.getMergeRequestsItem(
      this.$route.params.alias,
      this.$route.params.projectAlias,
      this.$route.params.id
    );

    if (this.applicationVersion !== 'onpremise') {
      MergeRequestService.getMergeRequestCodeOwners(
        this.$route.params.alias,
        this.$route.params.projectAlias,
        this.$route.params.id
      );
    }

    if (this.cicdEnabled) {
      try {
        // eslint-disable-next-line max-len, global-require
        const ciMainStatusComponent = require('@shared/modules/ci-cd/components/merge-request-ci-pipeline-status');
        // eslint-disable-next-line vue/match-component-file-name
        Vue.component('MergeRequestCiPipelineStatus', (resolve) => {
          resolve(ciMainStatusComponent);
        });
      } catch (e) {
        console.warn(
          // eslint-disable-next-line max-len
          'Merge request approvers module is NOT included in your package, if you need it - please contact our support'
        );
      }
      try {
        // eslint-disable-next-line max-len, global-require
        const ciTable = require('@shared/modules/ci-cd/components/ci-cd-pipelines-table');
        // eslint-disable-next-line vue/match-component-file-name
        Vue.component('CiCdPipelinesTable', (resolve) => {
          resolve(ciTable);
        });
      } catch (e) {
        console.warn(
          // eslint-disable-next-line max-len
          'CI/CD module is NOT included in your package, if you need it - please contact our support'
        );
      }
    }
  },
  i18n: {
    messages: mergeRequestMessages
  }
};
</script>

<style lang="scss">
$this: '.merge-request-item';
</style>
